// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.healthcare-service-details-layout {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.healthcare-service-details-badges {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.healthcare-service-details-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.9rem;
}

.healthcare-service-detail-card {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  padding: 1rem 1rem 0.95rem;
  border-radius: 0.85rem;
  background: rgba(0, 0, 0, 0.02);
  border: 0.0625rem solid rgba(0, 0, 0, 0.06);
}

.healthcare-service-detail-card-full {
  grid-column: 1 / -1;
}

.healthcare-service-detail-label {
  font-size: 0.85rem;
  font-weight: 700;
  color: var(--secondary-color);
  text-transform: uppercase;
  letter-spacing: 0.02em;
}

.healthcare-service-detail-value {
  color: var(--secondary-color);
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-wrap: wrap;
}

.healthcare-service-location-list {
  min-height: 2.5rem;
}

@media screen and (max-width: 991px) {
  .healthcare-service-details-grid {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/HealthcareServiceDetails/HealthcareServiceDetails.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,0BAA0B;EAC1B,sBAAsB;EACtB,+BAA+B;EAC/B,2CAA2C;AAC7C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,6BAA6B;EAC7B,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF","sourcesContent":[".healthcare-service-details-layout {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 1rem;\r\n}\r\n\r\n.healthcare-service-details-badges {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 0.5rem;\r\n}\r\n\r\n.healthcare-service-details-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(2, minmax(0, 1fr));\r\n  gap: 0.9rem;\r\n}\r\n\r\n.healthcare-service-detail-card {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.4rem;\r\n  padding: 1rem 1rem 0.95rem;\r\n  border-radius: 0.85rem;\r\n  background: rgba(0, 0, 0, 0.02);\r\n  border: 0.0625rem solid rgba(0, 0, 0, 0.06);\r\n}\r\n\r\n.healthcare-service-detail-card-full {\r\n  grid-column: 1 / -1;\r\n}\r\n\r\n.healthcare-service-detail-label {\r\n  font-size: 0.85rem;\r\n  font-weight: 700;\r\n  color: var(--secondary-color);\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.02em;\r\n}\r\n\r\n.healthcare-service-detail-value {\r\n  color: var(--secondary-color);\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.5rem;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.healthcare-service-location-list {\r\n  min-height: 2.5rem;\r\n}\r\n\r\n@media screen and (max-width: 991px) {\r\n  .healthcare-service-details-grid {\r\n    grid-template-columns: 1fr;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
